export enum ChatItemStatus {
  SENDING = "Sending",
  SENT = "Sent",
  DELIVERED = "Delivered",
  READ = "Read",
  UNDELIVERED = "Undelivered"
}
